import { Modal } from 'src/components';
import styled from 'styled-components';

const FormModalStyle = styled(Modal)`
  &.modal-form {
    .ant-form-item-required {
      display: flex;
      flex-direction: row-reverse;
      justify-content: start;
      gap: 2px;
    }

    .ant-form-item {
      margin: 0;
    }
    @media only screen and (max-width: 700px) {
      .col-avatar {
        display: none;
      }
      .col-form {
        min-width: 100%;
      }
    }
  }

  .title {
    min-width: 250px;
  }

  .sort-order {
    min-width: 100px;
    max-width: 250px;
  }

  .component {
    min-width: 120px;
  }

  .langue-select {
    display: flex;
    gap: 20px;
    align-items: center;
  }

  .no-data {
    text-align: center;
  }
`;

export default FormModalStyle;
